<template>
  <div class="welcome-container">
    <!-- Welcome Header -->
    <h1>{{ headerMsg }}</h1>
    <p class="description">
     {{ bodyMsg }}
    </p>

    

    <!-- Apply Button (Disabled until GDPR is accepted) -->
    <button  @click="goHome" class="apply-button mr-2">
      Home
    </button>

    <button v-if="status=='update'" :disabled="!gdprConsentGiven" @click="resumeApplication" class="resume-button">
      Resume Application
    </button>
  </div>
</template>

<script>
export default {
  props: ['params'],
  data() {
    return {
      agreeToGDPR: false,       // Tracks whether the user has agreed to GDPR notice
      gdprConsentGiven: false,  // Tracks if GDPR consent has been confirmed
      showGDPRModal: true,     // Controls the visibility of the GDPR modal
      headerMsg:'',
      bodyMsg:'',
      status:''
    };
  },
  mounted() {
    // Show the GDPR modal as soon as the component is mounted

    this.param = this.$route.params.params;
    this.status=this.$route.params.params;
    //console.log('Route param on mount:', this.params);
    if (this.status == 'success') {
     this.headerMsg='Submitted Successfully!!';
     this.bodyMsg='Form has been successfully submitted. We will get back to you'
    } else if(this.status=='update') {
     this.headerMsg='Saved Successfully!!';
     this.bodyMsg='Progress successfully saved'
    }else{
      this.headerMsg='Failed!!';
     this.bodyMsg='Unable to save form. Please try again'
    }
    
    const consent = localStorage.getItem("gdprConsent");
    if (consent === "true") {
      this.gdprConsentGiven = true;
      this.showGDPRModal = false;
    }
  },
  methods: {
    goHome() {
      // Start the application process (redirect to application form or initiate form steps)
      //this.$router.push('/apply'); // Adjust the route as needed
      // this.$router.push({ name: 'Apply', params: { params: 'start' } });
      window.location.replace('https://nessakud.com')

    },

    resumeApplication() {

      this.$router.push({ name: 'Apply', params: { params: 'resume' } });

    },

    confirmGDPRConsent() {
      this.gdprConsentGiven = true;
      this.showGDPRModal = false; // Close modal after consent is given
      localStorage.setItem("gdprConsent", "true");
    },
    closeConsentModal(){
      // this.showGDPRModal = false;
      window.location.replace('https://nessakud.com')
    }
  },
};
</script>

<style scoped>
/* Full-page background image with overlay */
/* body {
  background: url('../assets/bg.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
} */

body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  /* Dark overlay to improve readability */
  z-index: -1;
}

/* Centered container with shadow */
.welcome-container {
  max-width: 600px;
  margin: 5vh auto;
  padding: 3rem;
  text-align: center;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;

}

h1 {
  color: #007ad9;
  margin-bottom: 1rem;
}

.description {
  color: #555;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

/* Modal Style */
.modal {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal h2 {
  margin-bottom: 1rem;
  color: #007ad9;
}

/* Scrollable Textbox Style */
.scrollable-textbox {
  height: 60vh;
  /* Fixed height for scrolling */
  overflow-y: auto;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #333;
  background-color: #f9f9f9;
  text-align: left;
}

/* GDPR Section */
.gdpr-section {
  margin-bottom: 1.5rem;
}

.gdpr-section label {
  font-size: 1rem;
  color: #333;
}

/* Button Styles */
.modal-close-button,
.modal-confirm-button {
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0.5rem;
}

.modal-close-button {
  background-color: #ccc;
  color: #333;
}

.modal-confirm-button {
  background-color: #007ad9;
  color: #fff;
  transition: background-color 0.3s ease;
}

.modal-confirm-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.modal-confirm-button:hover:enabled {
  background-color: #005fa3;
}

.apply-button {
  padding: 0.8rem 2rem;
  font-size: 1rem;
  color: #fff;
  background-color: #16c94c;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.apply-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.apply-button:hover:enabled {

  background-color: #0f8f36;
}




.resume-button {
  padding: 0.8rem 2rem;
  font-size: 1rem;
  color: #fff;
  background-color: #007ad9;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.resume-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.resume-button:hover:enabled {
  background-color: #005fa3;
}


</style>
